import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RequestStatus } from "@app/constants";
import { IVeiwsProps } from "./types";

const initialState: IVeiwsProps = {
  views: {},
  getReviews: {},
  getAvgReviews:{},
  addReview : {},
};

const slice = createSlice({
  name: "views",
  initialState,
  reducers: {
    views(state, action: PayloadAction<any>) {
      state.views.status = RequestStatus.RUNNING;
    },
    viewsSuccess(state, action) {
      state.views.status = RequestStatus.SUCCESS;
      state.views.data = action.payload;
    },
    viewsFailed(state, action: PayloadAction<any>) {
      state.views.status = RequestStatus.ERROR;
      state.views.error = action.payload;
    },
    getReviews(state, action: PayloadAction<any>) {
      state.getReviews.status = RequestStatus.RUNNING;
    },
    getReviewsSuccess(state, action) {
      state.getReviews.status = RequestStatus.SUCCESS;
      state.getReviews.data = action.payload;
    },
    getReviewsFailed(state, action: PayloadAction<any>) {
      state.getReviews.status = RequestStatus.ERROR;
      state.getReviews.error = action.payload;
    },
    getAvgReviews(state, action: PayloadAction<any>) {
      state.getAvgReviews.status = RequestStatus.RUNNING;
    },
    getAvgReviewsSuccess(state, action) {
      state.getAvgReviews.status = RequestStatus.SUCCESS;
      state.getAvgReviews.data = action.payload;
    },
    getAvgReviewsFailed(state, action: PayloadAction<any>) {
      state.getAvgReviews.status = RequestStatus.ERROR;
      state.getAvgReviews.error = action.payload;
    },
    addReview(state, action: PayloadAction<any>) {
      state.addReview.status = RequestStatus.RUNNING;
    },
    addReviewSuccess(state, action) {
      state.addReview.status = RequestStatus.SUCCESS;
      state.addReview.data = action.payload;
    },
    addReviewFailed(state, action: PayloadAction<any>) {
      state.addReview.status = RequestStatus.ERROR;
      state.addReview.error = action.payload;
    },
  },
});

export default slice.reducer;
export const { views,viewsFailed,viewsSuccess , getReviews , getReviewsFailed, getReviewsSuccess , getAvgReviews,getAvgReviewsFailed,getAvgReviewsSuccess , addReview,addReviewFailed,addReviewSuccess} = slice.actions;
